import React, {  useEffect, useState } from 'react';
import {useUser} from '@wollo-lib/kpe-context'


export default function useShopId()
{
   const user=useUser()
   return user.ShopId
}
